<template>
    <div class="grid grid-cols-2 md:grid-cols-4 gap-2 w-full max-w-5xl">
        <NavCard v-for="site in sites" :key="site.name" v-bind="site" @click="handleCardClick(site)" />

        <SideDrawer :is-open="isDrawerOpen" :title="activeTool?.name" @close="handleClose">
            <!-- <component v-show="isDrawerOpen" :is="getToolComponent(activeTool?.toolId)" :key="activeTool?.toolId"
                ref="toolRef" /> -->
            <TimestampTool v-show="activeTool?.toolId === 'timestamp'" ref="timestampRef" />
            <JsonTool v-show="activeTool?.toolId === 'json-format'" ref="jsonRef" />
            <GeneratorTool v-show="activeTool?.toolId === 'random-gen'" ref="generatorRef" />
            <CryptoTool v-show="activeTool?.toolId === 'crypto-tool'" ref="cryptoRef" />
            <RichEditor v-show="activeTool?.toolId === 'rich-editor'" ref="richEditor" />
        </SideDrawer>
    </div>
</template>

<script setup>
import { ref, defineAsyncComponent } from 'vue';
import NavCard from './NavCard.vue';
import SideDrawer from './SideDrawer.vue';
import { NAV_SITES } from '../config/navData';

const sites = ref(NAV_SITES);
const isDrawerOpen = ref(false);
const activeTool = ref(null);

const timestampRef = ref(null); // 用于访问工具组件内部方法
const jsonRef = ref(null);
const generatorRef = ref(null);
const cryptoRef = ref(null);
const richEditor = ref(null);

// 异步加载工具内容，避免初始包体积过大
const TimestampTool = defineAsyncComponent(() => import('./tools/TimestampTool.vue'));
const JsonTool = defineAsyncComponent(() => import('./tools/JsonTool.vue'));
const GeneratorTool = defineAsyncComponent(() => import('./tools/GeneratorTool.vue'));
const CryptoTool = defineAsyncComponent(() => import('./tools/CryptoTool.vue'));
const RichEditor = defineAsyncComponent(() => import('./tools/RichEditor.vue'));


const handleClose = (source) => {
    if (source === 'button') {
        // 建立 toolId 和 ref 实例的映射关系
        const toolMap = {
            'timestamp': timestampRef.value,
            'json-format': jsonRef.value,
            'random-gen': generatorRef.value,
            'crypto-tool': cryptoRef.value,
            'rich-editor': richEditor.value
        };
        // 获取当前活跃组件的实例
        const activeInstance = toolMap[activeTool.value?.toolId];
        // 如果实例存在且暴露了 clearAll 方法，则执行它
        if (activeInstance && typeof activeInstance.clearAll === 'function') {
            activeInstance.clearAll();
        }
    }
    // 无论是哪种方式，都关闭抽屉
    isDrawerOpen.value = false;
};

const handleCardClick = (item) => {
    if (item.type === 'link') {
        window.open(item.url, '_blank');
    } else if (item.type === 'tool') {
        activeTool.value = item;
        // toolRef.value = item.ref
        isDrawerOpen.value = true;
    }
};

</script>